export default __webpack_public_path__ + "cf3b4135bd5ce23e5eb06074760cf91f.svg";